const Rack = {

    // FIELDS
    "rack_no": "Rack Number",
    "capacity": "Capacity",
    "location": "Location",
    "search": "Search",

    // PAGE HEADER
    "rack": "Rack",

    // ERROR
    "error_rack_no": "Enter Rack Number",
    "error_capacity": "Enter Capacity",
    "error_location": "Enter Location",
    "error_positive": "Enter Only Positive Number",

    // TABLE HEADER
    "table_rack_no": 'RACK NUMBER',
    "table_capacity": "CAPACITY",
    "table_location": "LOCATION",
}

export default Rack;